import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Modal, ModalHeader, ModalBody, ModalFooter, Button, Row, Col, FormGroup } from "reactstrap";
import { failed, success } from '../../../utils/Tostify';
import { useFormik } from 'formik';
import TextInput from '../../../components/InputFields/TextInput';
import InputFile from '../../../components/InputFields/InputFile';
import { formikAddApplicationReceipt } from '../Constant';
import Loader from "../../../components/Loader/Loader";
import { handleFileUpload } from "../../../utils/ImageToBase64";
import { addApplicationReceipt } from '../../../api/Applications';
import { getDocumentTypeList } from '../../../api/workflow';
import { decryptData } from '../../../utils/helper';

const AddReceipt = ({isOpen, getApplication, toggle , application, receiptData,patientDetails}) => {
  const dispatch = useDispatch();
  let token = useSelector((state) => state.userReducer.token);
  const [isLoading, setIsLoading] = useState(false);
  let user = useSelector((state) => state?.userReducer?.user);
  const [documentsOptions, setDocumentsOptions] = useState([]);

  const [selectedFile, setSelectedFile] = useState(null);

  const formik = useFormik({
      ...formikAddApplicationReceipt,
      onSubmit: async (values) => {
          let payload;
              let base64pdfForm = "";
              if (values?.docFile.name !== undefined) {
                  base64pdfForm = await handleFileUpload(values?.docFile);
                  const fileExtension = values?.docFile?.type?.split("/")[1];
                  const docFile = {
                      base64String: base64pdfForm,
                      extension: fileExtension, // Add the file extension to the object
                      name: values?.docFile.name
                  };
                  values.docFile = docFile;
              }
              payload = {
                title: values.docTitle,
                receiptFile: values.docFile,
                documentTypeId: values.documentType,
                uploadedBy: user._id
              };
          let res;
          try {
              setIsLoading(true);
              res = await addApplicationReceipt({ values: payload, dispatch, token, applicationId: application?._id ,patientId:patientDetails._id});
              if (res?.status === "SUCCESS") {
                  await getApplication();
                  success(res.message);
                  enhancedToggle();
                  setIsLoading(false);
              } else {
                  setIsLoading(false);
                  failed(res?.message);
              }
          } catch (error) {
              failed(res?.message);
              setIsLoading(false);
          }
      }
  });

  const enhancedToggle = () => {
    toggle();
    formik.resetForm();
    setSelectedFile(null);
  };

const getDocumentList = async (page, limit, searchKey = "") => {
    let res;
    try {
      setIsLoading(true);
      res = await getDocumentTypeList({ dispatch, token, page, limit, searchKey });
      const responseData = decryptData(res?.data);
      if (res?.status === "SUCCESS" && Array.isArray(responseData.items)) {
        const filteredItems = responseData.items.filter(doc => doc.isManageAdmin);
        const options = filteredItems.map((doc) => ({
          label: doc.documentTitle,
          value: doc._id
        }));
        setDocumentsOptions(options);
      } else {
        failed("Invalid response format or empty list");
      }
    } catch (error) {
      failed(res?.message || "Something went wrong");
    } finally {
      setIsLoading(false);
    }
  };

useEffect(() => {
    getDocumentList(1, 10);
}, []);

  return (
    <Modal isOpen={isOpen} toggle={enhancedToggle} size="lg">
    <ModalHeader toggle={enhancedToggle} className="assign_blk p-0 mb-3">Add Receipt</ModalHeader>
    <ModalBody className="form-add">
        {isLoading ? <Loader /> : null}
        <Row className="m-0">
                <Col lg={12} className="location_block p-0">
                    <FormGroup>
                        <TextInput
                            keyField={"docTitle"}
                            formik={formik}
                            label="Title"
                            required={true}
                            type="text"
                            // placeholder="Receipt Name"
                            value={formik.values.docTitle}
                            onChange={(e) => formik.setFieldValue("docTitle", e.target.value)}
                        />

                        <InputFile
                            keyField={"docFile"}
                            id="exampleFile"
                            name="file"
                            type="file"
                            inputFile="pdf"
                            formik={formik}
                            setFile={setSelectedFile}
                            imageUrl={selectedFile}
                            onChange={(e) => setSelectedFile(e.target.files[0])}
                        />
                    </FormGroup>
                </Col>
        </Row>
    </ModalBody>
    <ModalFooter>
        <div className="d-flex justify-content-between gap-2 flex-wrap">
            <Button color="secondary" onClick={enhancedToggle} className="save_btn cancel_btn">
                Cancel
            </Button>
            <Button color="primary" onClick={formik.handleSubmit} className="save_btn"> Save</Button>
        </div>
    </ModalFooter>
</Modal>
  );
};

export default AddReceipt;
